module.exports = __webpack_public_path__ + "img/NATA_Visual_0.5fc4ca10.png";